export const DefaultCurrencyFormat: Readonly<Intl.NumberFormatOptions> = {
  style: 'currency',
};
